import {
  UPDATE_PASSWORD_FIELD,
  type MobileDialogViewportStyle,
  type UpdatePasswordFieldId,
  type VisualViewportBox,
} from './update-password-dialog.types';

export function buildMobileDialogViewportStyle(
  insetPx: number,
  viewport: VisualViewportBox | null | undefined,
  fallbackHeight: number,
): MobileDialogViewportStyle {
  const top = (viewport?.offsetTop ?? 0) + insetPx;
  const height = (viewport?.height ?? fallbackHeight) - insetPx * 2;

  return {
    top: `${top}px`,
    maxHeight: `${Math.max(height, 0)}px`,
    transform: 'translate(-50%, 0)',
  };
}

export function getNextPasswordFieldId(
  currentFieldId: UpdatePasswordFieldId,
): UpdatePasswordFieldId | undefined {
  switch (currentFieldId) {
    case UPDATE_PASSWORD_FIELD.CURRENT:
      return UPDATE_PASSWORD_FIELD.NEW;
    case UPDATE_PASSWORD_FIELD.NEW:
      return UPDATE_PASSWORD_FIELD.CONFIRM;
    case UPDATE_PASSWORD_FIELD.CONFIRM:
      return undefined;
    default:
      return undefined;
  }
}

export function focusNextPasswordField(
  currentFieldId: UpdatePasswordFieldId,
): void {
  try {
    const nextFieldId = getNextPasswordFieldId(currentFieldId);
    if (!nextFieldId) {
      return;
    }

    document.getElementById(nextFieldId)?.focus();
  } catch (error) {
    console.error('Failed to move to the next password field', { error });
  }
}

export function scrollPasswordFieldIntoView(element: HTMLElement): void {
  try {
    element.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  } catch (error) {
    console.error('Failed to keep the password field on screen', { error });
  }
}
